import { Component, inject, OnInit, ViewChild } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { MatMenuModule } from '@angular/material/menu'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { AsyncPipe } from '@angular/common'
import { MeUser, UsersService } from '../users.service'
import { BannerComponent } from '../banner/banner.component'
import { SearchPanelComponent } from '../search-panel/search-panel.component'
import { CallsService } from '../calls.service'
import { MatDialog } from '@angular/material/dialog'
import { IntercomService } from '../intercom.service'
import { SideMenuComponent } from '../side-menu/side-menu.component'
import { SettingsService } from '../settings.service'
import { filter, map } from 'rxjs'

@Component({
  selector: 'app-app-page',
  standalone: true,
  imports: [MatMenuModule, MatIconModule, MatTooltipModule, RouterOutlet, TranslateModule, AsyncPipe, BannerComponent, SearchPanelComponent, SideMenuComponent],
  templateUrl: './app-page.component.html',
  styleUrl: './app-page.component.scss',
})
export class AppPageComponent implements OnInit {
  @ViewChild(SideMenuComponent)
  sideMenuComponent: SideMenuComponent | undefined = undefined

  usersService = inject(UsersService)
  callsService = inject(CallsService)
  dialog = inject(MatDialog)
  translateService = inject(TranslateService)
  intercomService = inject(IntercomService)
  settingsService = inject(SettingsService)
  currentUser$ = this.usersService.currentUser$

  ngOnInit() {
    this.intercomService.initialize()
    this.initializeUserLocale()
  }

  private initializeUserLocale() {
    this.settingsService
      .getUserSettings()
      .pipe(
        filter((result) => result.isSuccess),
        map((result) => result.data)
      )
      .subscribe((data) => {
        if (data?.locale) {
          const localeMap: { [key: string]: string } = {
            EN_US: 'en_US',
            EN_GB: 'en_GB',
          }
          const translationKey = localeMap[data.locale] ?? 'en_GB'
          this.translateService.use(translationKey)
        }
      })
  }

  displayCalendarConnectBanner(user: MeUser): boolean {
    return user.organization.isCalendarSynchronizationEnabled && user.calendarProviders.every((calendar) => calendar.email === null)
  }
}
